import { render, staticRenderFns } from "./FpuiInputPassword.vue?vue&type=template&id=227c5473&lang=pug&"
import script from "./FpuiInputPassword.vue?vue&type=script&lang=js&"
export * from "./FpuiInputPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports